import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {},
  fields: {
    "$root&>div": {},
  },
  input: {
    height: 86,
  },
  cameraSpecificities: {
    height: "22px",
  },
  gridPaddingOverRide: {
    padding: "0 15px",
  },
  item: {
    padding: "0 15px",
    marginBottom: 0,
  },
  checkBoxMargin: {
    marginBottom: 30,
  },
}));

export default useStyles;
